module.exports = __webpack_public_path__ + "img/sezione_pet.5102a2ea.jpg";